<template>
    <Head title="Register Nome de Usuário" />
        <GuestLayout>
        <article>
            <div class="sm:px-5 xl:w-[350px] xl:max-w-[350px]">
                <h2 class="text-3xl font-semibold text-primary text-left xl:py-6 sm:py-4">Nome de Usuário</h2>
                <p class="pb-2">
                    Qual o nome de usuário <br />
                    que você gostaria de usar
                    para logar?
                </p>

                <form @submit.prevent="submit">
                    <ul class="grid gap-y-14 pt-4">
                        <li>
                            <label class="mb-1 mr-5 flex font-semibold pb-1">
                                Nome de Usuário
                            </label>
                            <Input
                                placeholder="Preecha aqui o seu nome de usuário.."
                                type="text"
                                required
                                v-model="form.username"
                            />
                        </li>
   
                        <li>
                            <button
                                class="
                                    w-full
                                    grid
                                    justify-items-center
                                    items-center
                                    text-primary
                                    border-primary border rounded
                                    hover:bg-gray-300
                                    hover:border-transparent
                                    font-semibold
                                    p-1.5
                                "
                            >
                                Avançar
                            </button>
                        </li>
                        <div v-if="$page.props.flash.error" class="flashError text-[10px] text-error">
                            {{ $page.props.flash.error }}
                        </div>
                    </ul>
                </form>
            </div>
        </article>
    </GuestLayout>
</template>

<script>
import HeaderComponent from "@/Components/Header.vue";
import Input from "@/Components/UI/Form/Input.vue";
import GuestLayout from "@/Layouts/Guest.vue";
import Label from "@/Components/Label.vue";
import ValidationErrors from "@/Components/ValidationErrors.vue";
import { Head, Link } from "@inertiajs/inertia-vue3";

export default {
    components: {
        HeaderComponent,
        Input,
        Label,
        ValidationErrors,
        Head,
        Link,
        GuestLayout
    },

    props: {
        apelido: String,
    },

    data() {
        return {
            form: this.$inertia.form({
                username: "",
            }),
        };
    },

    methods: {
        submit() {
            console.log(this.form);
            sessionStorage.setItem('username', this.form.username);
            this.$inertia.post("/register/nome-de-usuario", this.form);
        },
    },
};
</script>
